<div *ngIf="loading" style="margin-top: 16px;display: flex;justify-content: center;">
  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
  </p-progressSpinner>
</div>

<div *ngIf="!loading">
  <div class="row   justify-content-start mb-2">
    <div class="col-9">
      <span class="iso-header ml-3">
  {{'bikeshop.menu.settings' | translate}}
</span>
    </div>
    <!--  <div class="col-3 justify-content-end d-flex">-->
    <!--    <daz-icon class="iso-search-icon" [name]="'search'" [size]="'22px'"-->
    <!--              [color]="'#888888'"></daz-icon>-->
    <!--    <input (keyup)="searchSettings()" [(ngModel)]="searchTerm" class="iso-search-bar" type="text"-->
    <!--           placeholder="Search">-->

    <!--  </div>-->
  </div>
  <!-- <div class="row ml-2 mr-1">
    <div class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3  mb-1 p-1">
      <app-menu-panel class="rental-panel" [navigationItems]="general" [header]="'bikeshop.shop_setup.header.general'"
                      [icon]="'settings-generel'">
      </app-menu-panel>
    </div>
    <div class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3  mb-1 p-1">
      <app-menu-panel class="rental-panel" [navigationItems]="rentals" [header]="'bikeshop.shop_setup.header.rentals'"
                      [icon]="'ticket-simple'">
      </app-menu-panel>
    </div>
    <div class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3  mb-1 p-1">
      <app-menu-panel class="rental-panel" [navigationItems]="messaging"
                      [header]="'bikeshop.shop_setup.header.messaging'"
                      [icon]="'message-circle'">
      </app-menu-panel>
    </div>

    <div class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3  mb-1 p-1">
      <app-menu-panel class="rental-panel" [navigationItems]="plugins" [header]="'Plugins'"
                      [icon]="'browser'">
      </app-menu-panel>
    </div>
  </div> -->


  <div class="flex-container">
    <div>
      <app-menu-panel class="rental-panel" [navigationItems]="general" [header]="'bikeshop.shop_setup.header.general'"
                      [icon]="'settings-generel'">
      </app-menu-panel>
    </div>
    <div>
      <app-menu-panel class="rental-panel" [navigationItems]="rentals" [header]="'bikeshop.shop_setup.header.rentals'"
                      [icon]="'ticket-simple'">
      </app-menu-panel>
    </div>
    <div>
      <app-menu-panel class="rental-panel" [navigationItems]="messaging"
                      [header]="'bikeshop.shop_setup.header.messaging'"
                      [icon]="'message-circle'">
      </app-menu-panel>
    </div>

    <div>
      <app-menu-panel class="rental-panel" [navigationItems]="plugins" [header]="'Plugins'"
                      [icon]="'browser'">
      </app-menu-panel>
    </div>
  </div>

</div>
